"use client";
import { setHamburgerState } from "@/store";
import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslations } from "next-intl";
import { useDispatch, useSelector } from "react-redux";
import { HeaderBtnGroup } from "./HeaderBtnGroup";
import { Navigation } from "./Navigation";

const { Panel } = Dialog;

export const Hamburger = ({ nameSite,lang,currency }) => {
  const t = useTranslations();
  const { isOpenHamburger } = useSelector((state) => state.common);
  const dispatch = useDispatch();
  const onCloseHandler = () => dispatch(setHamburgerState(false));

  return (
    <Dialog
      as="div"
      className="xl:hidden"
      open={isOpenHamburger}
      onClose={onCloseHandler}
    >
      <div className="fixed inset-0 z-10" />
      <Panel className="fixed inset-y-0 right-0 z-9999 w-full overflow-y-auto bg-white sm:px-6 px-2 sm:py-6 py-4 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
        <div className="flex items-center justify-end">
          <button
            type="button"
            className="-m-2.5 rounded-md p-2.5 text-gray-700"
            onClick={onCloseHandler}
          >
            <span className="sr-only">Close menu</span>
            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="mt-6 flow-root">
          <div className="-my-6 ">
            <div className="space-y-2 py-6 lg:hidden">
              <Navigation type="mobile" />
            </div>
            <HeaderBtnGroup lang={lang} currency={currency} mobile={true} />
          </div>
        </div>
      </Panel>
    </Dialog>
  );
};
